import Spinner from '@/components/atoms/Spinner'
import { List as CourseLive } from '@/components/organisms/Admin/Course/Live/List'
import { List as CourseRecorded } from '@/components/organisms/Admin/Course/Recorded'
import cohortsService from '@/services/cohortsService'
import { matriculateCreators } from '@/store/ducks/matriculate'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { useEffect } from 'react'

export function CoursePage() {
	const {
		auth: { user },
		matriculate: { classSelect },
	} = useAppSelector((state) => state)

	const dispatch = useAppDispatch()

	const {
		data: cohorts,
		isLoading,
		isSuccess,
	} = cohortsService.getCohortsUser()

	const handleCoursesFirst = async () => {
		const getCourseFirstAndLast = Number(cohorts?.courses?.length) - 1 || 0

		if (cohorts?.courses[getCourseFirstAndLast]) {
			await dispatch(
				matriculateCreators.setClassSelect({
					id: cohorts?.courses[getCourseFirstAndLast]?.id,
					name: cohorts?.courses[getCourseFirstAndLast]?.name || '',
					curso_id: cohorts?.courses[getCourseFirstAndLast]?.curso_id || 0,
					'type-course':
						cohorts?.courses[getCourseFirstAndLast]?.['type-course'],
				})
			)
		} else if (user?.curso_interesse_id) {
			await dispatch(
				matriculateCreators.setClassSelect({
					id: user?.curso_interesse_id,
					name: '',
					curso_id: user?.curso_interesse_id,
					'type-course': 'AO VIVO',
				})
			)
		}
	}

	const handleCourseFinishOnboarding = async () => {
		const itemFinishedOnboarding = user?.onboarding_all?.find(
			(onboarding) =>
				onboarding.curso_id === classSelect?.curso_id &&
				onboarding.nivel_onboarding === 5
		)

		const cohort = cohorts?.courses?.find(
			(cohort) => cohort.curso_id === itemFinishedOnboarding?.curso_id
		)

		if (cohort)
			dispatch(
				matriculateCreators.setClassSelect({
					id: cohort.id,
					name: '',
					curso_id: cohort?.curso_id,
					'type-course': 'AO VIVO',
				})
			)
	}

	useEffect(() => {
		if (!classSelect && isSuccess) handleCoursesFirst()

		if (classSelect?.id === classSelect?.curso_id)
			handleCourseFinishOnboarding()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [classSelect, isSuccess])

	return (
		<div className='flex flex-col w-full relative z-10 overflow-clip'>
			{(() => {
				if (!classSelect && isLoading) {
					return (
						<div className='flex h-full justify-center py-10'>
							<Spinner />
						</div>
					)
				}

				if (
					['GRAVADO'].includes(
						classSelect?.['type-course']?.toUpperCase() || ''
					)
				) {
					return <CourseRecorded />
				}

				if (
					['AO VIVO'].includes(
						classSelect?.['type-course']?.toUpperCase() || ''
					)
				) {
					return <CourseLive />
				}

				return <></>
			})()}
		</div>
	)
}
